export default "__VITE_ASSET__wCuJAIEc__"